import React from "react";
import { Wrapper } from "./CompleteForm.styles";
import ShareLink from "../../../components/CreateForm/Complete/ShareLink";

function CompleteForm() {
  return (
    <Wrapper>
      <ShareLink />
    </Wrapper>
  );
}

export default CompleteForm;
